// extracted by mini-css-extract-plugin
module.exports = {"priorityOrder":"_1-2lQa5xerUIjDilgoykiX","applyChangesButton":"_1cAhWHoOr9HCiyGonKiRtY","policyListHeader":"_2SJJs4Hfeuo8XdhmW1qDdM"};